import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { router } from './router/router';
import { AuthProvider } from './context/AuthProvider';
import { CartProvider } from './context/CartCtx';
import { ThemeProvider } from './context/ThemeCtx';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from './util/queryClient';

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ThemeProvider>
          <CartProvider>
            <RouterProvider router={router}></RouterProvider>
          </CartProvider>
        </ThemeProvider>
      </AuthProvider>
      <ReactQueryDevtools initialIsOpen={true} />
    </QueryClientProvider>
  );
}

export default App;
